<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <div>
            <page-loading v-if="!billing"></page-loading>
            <template v-else>
                <org-unit-billing-details
                    :teamId="props.teamId"
                    :orgUnitId="props.orgUnitId"
                    :billing="billing"
                    :isAdminOrOwner="isAdminOrOwner"
                />
            </template>
        </div>
    </org-unit-details>
</template>

<script setup>
import OrgUnitBillingDetails from './OrgUnitBillingDetails.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import OrgUnitDetails from '../form/OrgUnitDetails.vue';
import { ref, onMounted } from 'vue';
import { orgUnitBillingClient } from '~/services';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const billing = ref(null);
const isAdminOrOwner = Spark.isAdminOrOwner;
const $toasted = useToasted();

const getBillingDetails = async () => {
    try {
        const response = await orgUnitBillingClient.getBillingDetails(props.teamId, props.orgUnitId);
        billing.value = response.data;
    } catch (error) {
        console.error('Failed to fetch billing details:', error);
        $toasted.error('Failed to load billing details. Please try again.');
    }
};

onMounted(() => {
    getBillingDetails();
});
</script>
